import { PassengerType } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useCallback } from "react";

export const usePassengerTypeString = () => {
  const { t } = useI18nContext();

  return useCallback(
    (passengerType: PassengerType) => {
      switch (passengerType) {
        case PassengerType.Adult: {
          return t("passengerInformation.adult");
        }
        case PassengerType.InfantInSeat: {
          return t("passengerInformation.infant");
        }
        case PassengerType.InfantInLap: {
          return t("passengerInformation.infant");
        }
        case PassengerType.Child: {
          return t("passengerInformation.child");
        }
      }
    },
    [t]
  );
};
